import React from 'react';
import PropTypes from 'prop-types';
import OutboundLink from '../common/OutboundLink';
import withArticleTracking from '../common/withArticleTracking';

const Social = ({
  className,
  href,
  parent,
  icon
}) => {
  const actionType = className.split('-')[1];
  const TrackedOutboundLink = withArticleTracking(OutboundLink);

  return (
    <TrackedOutboundLink
      className={`social social-${className}`}
      href={href}
      dataEventName="social_redirected"
      actionType={actionType}
      moduleName={parent}>
      {icon}
    </TrackedOutboundLink>
  );
};

Social.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default Social;
